export const DO_GET_ORDERTYPE = "DO_GET_ORDERTYPE";
export const DO_GET_ORDERTYPE_SUCCESS = "DO_GET_ORDERTYPE_SUCCESS";
export const DO_GET_ORDERTYPE_FAILED = "DO_GET_ORDERTYPE_FAILED";

export const DO_SET_FILTER_ORDERTYPE = "DO_SET_FILTER_ORDERTYPE";
export const DO_UPDATE_ITEM_ORDERTYPE = "DO_UPDATE_ITEM_ORDERTYPE";
export const RESET_MODIFIED_ORDERTYPE = "RESET_MODIFIED_ORDERTYPE";

export const SET_ERROR_ORDERTYPE = "SET_ERROR_ORDERTYPE";
